import React from "react";
import {components} from "react-select";

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <svg width="18" height="18" viewBox="0 0 24 24" focusable="false" role="presentation">
                <path
                    d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
                    fill="currentColor"
                    fillRule="evenodd"
                />
            </svg>
        </components.DropdownIndicator>
    );
};

export default DropdownIndicator;